import { AttributeMap, TRAINEE_REQUIREMENT, TraineeRequirement } from 'src/store/slices/job-stage-interview-seat';

import { hasSelectedAttributes } from '../memberFiltering';

import { SOURCE_MODE, SourceMode } from './seatSettingsTypes';

/** Whether reverse-shadow trainees are included in the seat requirement. */
export const isReverseShadowRequirementEnabled = (requirement: TraineeRequirement): boolean =>
  requirement === TRAINEE_REQUIREMENT.ANY || requirement === TRAINEE_REQUIREMENT.REVERSE_SHADOW;

/** Whether shadow trainees are included in the seat requirement. */
export const isShadowRequirementEnabled = (requirement: TraineeRequirement): boolean =>
  requirement === TRAINEE_REQUIREMENT.ANY || requirement === TRAINEE_REQUIREMENT.SHADOW;

/** Derives the persisted trainee requirement from per-role row toggles. */
export const traineeRequirementFromToggles = ({
  reverseShadowEnabled,
  shadowEnabled,
}: {
  reverseShadowEnabled: boolean;
  shadowEnabled: boolean;
}): TraineeRequirement => {
  if (reverseShadowEnabled && shadowEnabled) {
    return TRAINEE_REQUIREMENT.ANY;
  }
  if (reverseShadowEnabled) {
    return TRAINEE_REQUIREMENT.REVERSE_SHADOW;
  }
  if (shadowEnabled) {
    return TRAINEE_REQUIREMENT.SHADOW;
  }
  return TRAINEE_REQUIREMENT.NONE;
};

export const getInTrainingSourceMode = ({
  attributeMap,
  hasPeople,
}: {
  attributeMap?: AttributeMap;
  hasPeople: boolean;
}): SourceMode => {
  if (hasPeople) {
    return SOURCE_MODE.PEOPLE;
  }
  if (hasSelectedAttributes(attributeMap)) {
    return SOURCE_MODE.ATTRIBUTES;
  }
  return SOURCE_MODE.PEOPLE;
};

export const addAttribute = (attributeMap: AttributeMap | undefined, nameId: string, valueId: string): AttributeMap => {
  const next: AttributeMap = { ...attributeMap };
  next[nameId] = [...(next[nameId] ?? []), valueId];
  return next;
};

export const removeAttribute = (
  attributeMap: AttributeMap | undefined,
  nameId: string,
  valueId: string
): AttributeMap => {
  const next: AttributeMap = { ...attributeMap };
  next[nameId] = (next[nameId] ?? []).filter((id) => id !== valueId);
  if (next[nameId].length === 0) {
    delete next[nameId];
  }
  return next;
};

export const countAttributeValues = (map?: AttributeMap): number =>
  Object.values(map ?? {}).reduce((count, values) => count + (values?.length ?? 0), 0);
